import axios from 'axios';
import { APIS } from '../../../../../../utils/api-factory';
import { POST_HEADER } from '../../../../../../utils/apiHeaders';


export const GetAllRefrence = (callBack, error) => {
    axios.get(APIS.GET_ALL_REFERENCE_DATA)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const GetRefrenceByRefrenceCodes = (employee, callBack, error) => {
    axios.get(APIS.GET_ALL_REFRENCE_BY_REFRENCE_CODES + employee)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getDistinctEmployees = ( callBack, error) => {
    axios.get(APIS.GET_DISTINCT_EMPLOYEES )
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const SaveGenerateRefrenceCodes = (data, callBack, error) => {
     const headerConfig = {
        headers:POST_HEADER
    };
    axios.post(APIS.SAVE_OR_GENERATE_REFRENCE_CODES ,data,headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getRefrenceCountByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_REFRENCE_DASHBOARD_COUNT_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getLoanStatusRefrenceByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_LOAN_STATUS_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getRejectionStatusRefrenceByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_REJECTION_STATS_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getConversionDetailsRefrenceByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_CONVERSION_STATS_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getDisbursedStatsRefrenceByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_DISBURSED_STATS_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getAppliedcoutnRefrenceByDate = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_APPLIED_COUNT_STATS_BY_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getDisbursedStatsRefrenceByDateLead = (start,end,refrence, callBack, error) => {
    axios.get(APIS.GET_DISBURSED_STATS_BY_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const getAppliedCOuntStatsByRefrneceDate = (start,end,refrence,size,count,data, callBack, error) => {
    const headerConfig = {
        headers:POST_HEADER
    };
    axios.post(APIS.GET_APPLIED_DATA_BY_REFRENCE_BY_DATE + start + "&endDate=" + end + "&referenceCode=" + refrence + "&pageNo=" + size + "&count=" + count,data,headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
export const DeleteRefrneceById = (id, callBack, error) => {
    const headerConfig = {
        headers:POST_HEADER
    };
    axios.delete(APIS.DELETE_REFRENCE_BY_ID + id,headerConfig)
        .then(res => {
            callBack(res?.data)
        })
        .catch(e => {
            callBack("")
        })
}
